import Road1 from '..//..//assets/road-1.jpg';
import Road2 from '..//..//assets/road-2.jpg';
import Road3 from '..//..//assets/road-3.jpg';
import Road4 from '..//..//assets/road-4.jpg';

import wareHouse1 from '..//..//assets/warehouse1.jpg';
import wareHouse2 from '..//..//assets/warehouse2.jpg';
import wareHouse3 from '..//..//assets/warehouse3.jpg';
import wareHouse4 from '..//..//assets/warehouse4.jpg';

import paverkunigal1 from '..//..//assets/paver-work/paver-kunigal-1.jpg';
import paverkunigal2 from '..//..//assets/paver-work/paver-kunigal-2.jpg';
import paverSivapura from '..//..//assets/paver-work/paver-sivapura.mp4';
import paverHolalkere from '..//..//assets/paver-work/paver-holalkere.mp4';
import paverImgHolalkere from '..//..//assets/paver-work/paver-holalkere.jpg';

// Mudigere project images
import mudigere1 from '..//..//assets/paver-work/paver-mudigereImg-1.jpg';
import mudigere2 from '..//..//assets/paver-work/paver-mudigereImg-2.jpg';
import mudigere3 from '..//..//assets/paver-work/paver-mudigereImg-3.jpg';

// Additional project images
import ioclMalladihalli from '..//..//assets/paver-work/paver-IOCL-petrol-bunk-malladihalli.jpg';
import kanchiganal1 from '..//..//assets/paver-work/paver-grampanchayat-kanchiganal.jpg';
import haliyalaChannagiri from '..//..//assets/paver-work/paver-haliyala-channagiri.jpg';
import hotelHiriyur from '..//..//assets/paver-work/paver-hotel-hiriyur.jpg';
import kanchiganal2 from '..//..//assets/paver-work/paver-kanchiganal.jpg';
import sivapura2 from '..//..//assets/paver-work/paver-sivapura-2.jpg';
import channappanahatti from '..//..//assets/paver-work/paver-residential-building-Channppanahtti.jpg';

const projectsData = [
  {
    id: 1,
    title: 'Asphalt Road Project',
    description1:
      'Our dedicated civil team recently achieved a significant milestone by completing a comprehensive road construction project that has transformed local infrastructure and connectivity.',
    description2:
      'This project, undertaken with unwavering commitment and technical expertise, has not only improved the physical landscape but also enhanced the lives of residents and travelers within the community.',
    year:2022,
    image: [Road1, Road2, Road3, Road4],
    location: 'Malladihalli',
    type:"Road Construction",
    features: [
      'High-quality construction materials',
      'Expert engineering and planning',
      'Timely project completion',
      'Sustainable construction practices',
      'Precision leveling and compaction',
      'Quality assurance and testing'
    ]
  },
  { 
    id: 2,
    title: 'Warehouse Construction',
    description1:
      'We are thrilled to announce the successful completion of Warehouse Project, a remarkable warehouse construction endeavor that underscores our unwavering commitment to excellence and innovation in the construction industry.',
    description2:
      'We turn your visions into reality, and Warehouse Project is a testament to our dedication.',
    year:2022,
    image: [wareHouse1, wareHouse2, wareHouse3, wareHouse4],
    location: 'Malladihalli',
    type:"Warehouse Construction",
    features: [
      'High-quality construction materials',
      'Expert engineering and planning',
      'Timely project completion',
      'Sustainable construction practices',
      'Precision leveling and compaction',
      'Quality assurance and testing'
    ]
  },
  {
    id: 3,
    title: 'Nysiri Resorts Pavement Work',
    description1: 'Luxury paver block installation at Nysiri Resorts in Mudigere, creating an impressive entrance and outdoor area for guests.',
    description2: 'Our high-end paving solution has significantly enhanced the resort\'s exterior aesthetics and guest experience, blending perfectly with the natural surroundings.',
    year: 2025,
    image: [mudigere1, mudigere2, mudigere3],
    location: 'Mudigere',
    type: 'Resort Pavement',
    features: [
      'Premium interlocking concrete pavers',
      'Custom design to match the landscape',
      'Expert installation with attention to detail',
      'Proper base preparation and compaction',
      'Weather-resistant and durable finish',
      'Enhanced curb appeal and functionality'
    ]
  },
  {
    id: 4,
    title: 'Hotel Premises Paving',
    description1: 'Luxury paver block installation at a hotel in Hiriyur, creating an impressive entrance and outdoor area for guests.',
    description2: 'Our high-end paving solution has significantly enhanced the hotel\'s exterior aesthetics and guest experience.',
    year: 2025,
    image: [hotelHiriyur],
    location: 'Hiriyur',
    type: 'Hospitality Project',
    features: [
      'Premium quality pavers',
      'Luxury design patterns',
      'Heavy-duty construction',
      'Weather-resistant finish',
      'Professional installation',
      'Enhanced guest experience'
    ]
  },
  {
    id: 5,
    title: 'Residential Building Pavement',
    description1: 'Elegant paver block installation at a residential building in Channappanahatti, enhancing the property\'s exterior aesthetics and functionality.',
    description2: 'This project showcases our ability to create beautiful and durable outdoor living spaces that complement residential architecture.',
    year: 2025,
    image: [channappanahatti],
    location: 'Channappanahatti',
    type: 'Residential Pavement',
    features: [
      'Premium quality interlocking pavers',
      'Aesthetically pleasing design',
      'Expert installation',
      'Durable and long-lasting finish',
      'Enhanced property value',
      'Custom pattern design'
    ]
  },
  {
    id: 6,
    title: 'Paver Block Installation',
    description1:
      'Our expert team successfully completed a premium paver block installation project, enhancing the aesthetic appeal and functionality of the outdoor space.',
    description2:
      'Using high-quality interlocking concrete pavers, we created durable and visually appealing walkways that combine beauty with long-lasting performance, designed to withstand heavy foot traffic and weather conditions.',
    year:2025,
    image: [paverkunigal1, paverkunigal2],
    location: 'Kunugali',
    type: "Paver Block Work",
    features: [
      'Premium interlocking concrete pavers',
      'Durable and weather-resistant materials',
      'Expert pattern design and installation',
      'Proper drainage and base preparation',
      'Precision leveling and compaction',
      'Long-lasting and low maintenance'
    ]
  },
  {
    id: 7,
    title: 'Paver Block Installation',
    description1:
      'Watch our team in action as we complete a premium paver block installation project in Sivapura, showcasing our process and attention to detail.',
    description2:
      'This video highlights our expert team working with high-quality interlocking concrete pavers, demonstrating our commitment to precision and quality in every project.',
    year: 2025,
    video: paverSivapura,
    location: 'Sivapura',
    type: 'Paver Block Work',
    features: [
      'Premium interlocking concrete pavers',
      'Durable and weather-resistant materials',
      'Expert pattern design and installation',
      'Proper drainage and base preparation',
      'Precision leveling and compaction',
      'Long-lasting and low maintenance'
    ]
  },
  {
    id: 8,
    title: 'Paver Block Installation',
    description1:
      'Our team completed a stunning paver block installation in Holalkere, transforming the outdoor space with beautiful and durable interlocking pavers.',
    description2:
      'This project showcases our expertise in creating functional and aesthetically pleasing hardscapes that stand the test of time while enhancing the property\'s curb appeal.',
    year: 2025,
    video: paverHolalkere,
    image: [paverImgHolalkere], 
    location: 'Holalkere',
    type: 'Paver Block Work',
    features: [
      'High-quality interlocking concrete pavers',
      'Custom pattern design for visual appeal',
      'Expert installation with attention to detail',
      'Proper base preparation and compaction',
      'Durable and weather-resistant finish',
      'Enhanced property value and aesthetics'
    ]
  },
  {
    id: 9,
    title: 'IOCL Petrol Bunk Pavement',
    description1: 'Professional paver block installation at IOCL Petrol Bunk in Malladihalli, featuring durable and visually appealing interlocking pavers.',
    description2: 'Our team delivered a high-quality, long-lasting pavement solution that enhances the aesthetic appeal and functionality of the petrol bunk area.',
    year: 2025,
    image: [ioclMalladihalli],
    location: 'Malladihalli',
    type: 'Commercial Pavement',
    features: [
      'Heavy-duty interlocking pavers',
      'Designed for high-traffic areas',
      'Oil and stain-resistant surface',
      'Durable and long-lasting finish',
      'Enhanced safety with non-slip surface',
      'Professional installation'
    ]
  },
  {
    id: 10,
    title: 'Grampanchayat Premises',
    description1: 'Complete paver block installation at Grampanchayat office in Kanchiganal, creating a clean and professional look for the government building.',
    description2: 'This project showcases our ability to work with government institutions to deliver high-quality public infrastructure.',
    year: 2025,
    image: [kanchiganal1],
    location: 'Kanchiganal',
    type: 'Government Project',
    features: [
      'Aesthetically pleasing design',
      'Durable construction',
      'Low maintenance requirements',
      'Weather-resistant materials',
      'Professional workmanship',
      'Timely completion'
    ]
  },
  {
    id: 11,
    title: 'Residential Compound Pavement',
    description1: 'Beautiful paver block installation in Haliyala, Channagiri, enhancing the residential property with elegant and durable paving.',
    description2: 'Our team created a stunning outdoor space that combines functionality with visual appeal.',
    year: 2025,
    image: [haliyalaChannagiri],
    location: 'Haliyala, Channagiri',
    type: 'Residential Pavement',
    features: [
      'Elegant design patterns',
      'High-quality materials',
      'Expert installation',
      'Custom color options',
      'Durable construction',
      'Enhanced curb appeal'
    ]
  },
  {
    id: 12,
    title: 'Commercial Complex Paving',
    description1: 'Commercial-grade paver block installation in Kanchiganal, designed to handle heavy foot traffic and vehicle loads.',
    description2: 'Our solution provides both durability and visual appeal for this high-traffic commercial area.',
    year: 2025,
    image: [kanchiganal2],
    location: 'Kanchiganal',
    type: 'Commercial Pavement',
    features: [
      'Heavy-duty construction',
      'High-traffic durability',
      'Aesthetically pleasing design',
      'Low maintenance',
      'Weather-resistant',
      'Professional finish'
    ]
  },
  {
    id: 13,
    title: 'Sivapura Paver Block Work',
    description1: 'Professional paver block installation in Sivapura, showcasing our expertise in creating durable and visually appealing outdoor spaces.',
    description2: 'This project highlights our commitment to quality workmanship and attention to detail in every installation.',
    year: 2025,
    image: [sivapura2],
    location: 'Sivapura',
    type: 'Paver Block Work',
    features: [
      'High-quality interlocking pavers',
      'Precision installation',
      'Durable construction',
      'Weather-resistant finish',
      'Enhanced curb appeal',
      'Professional workmanship'
    ]
  }
];

export default projectsData;
